var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCplusplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100px",
    height: "100px",
    viewBox: "0 0 150 168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(36.078431%,55.294118%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 149.746094 49.421875 C 149.746094 46.601562 149.140625 44.113281 147.917969 41.976562 C 146.714844 39.875 144.914062 38.113281 142.5 36.722656 C 122.5625 25.277344 102.605469 13.867188 82.675781 2.410156 C 77.304688 -0.675781 72.09375 -0.5625 66.761719 2.570312 C 58.824219 7.226562 19.097656 29.886719 7.257812 36.714844 C 2.382812 39.523438 0.0078125 43.824219 0.0078125 49.414062 C 0 72.429688 0.0078125 95.445312 0 118.460938 C 0 121.214844 0.582031 123.65625 1.75 125.761719 C 2.953125 127.925781 4.78125 129.738281 7.25 131.160156 C 19.089844 137.988281 58.824219 160.648438 66.757812 165.308594 C 72.09375 168.441406 77.304688 168.554688 82.679688 165.464844 C 102.609375 154.007812 122.566406 142.597656 142.503906 131.152344 C 144.976562 129.730469 146.800781 127.917969 148.003906 125.757812 C 149.171875 123.652344 149.753906 121.210938 149.753906 118.453125 C 149.753906 118.453125 149.753906 72.4375 149.746094 49.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.196078%,27.45098%,45.490196%)",
      fillOpacity: 1
    },
    d: "M 75.105469 83.714844 L 1.75 125.761719 C 2.953125 127.925781 4.78125 129.738281 7.25 131.160156 C 19.089844 137.988281 58.824219 160.648438 66.757812 165.308594 C 72.09375 168.441406 77.304688 168.554688 82.679688 165.464844 C 102.609375 154.007812 122.566406 142.597656 142.503906 131.152344 C 144.976562 129.730469 146.800781 127.917969 148.003906 125.757812 L 75.105469 83.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.196078%,27.45098%,45.490196%)",
      fillOpacity: 1
    },
    d: "M 53.378906 96.167969 C 57.648438 103.585938 65.671875 108.589844 74.878906 108.589844 C 84.140625 108.589844 92.210938 103.523438 96.457031 96.027344 L 75.105469 83.714844 L 53.378906 96.167969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,34.901961%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 149.746094 49.421875 C 149.746094 46.601562 149.140625 44.113281 147.917969 41.976562 L 75.105469 83.714844 L 148.003906 125.757812 C 149.171875 123.652344 149.753906 121.210938 149.753906 118.453125 C 149.753906 118.453125 149.753906 72.4375 149.746094 49.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 145.738281 86.71875 L 140.042969 86.71875 L 140.042969 92.390625 L 134.34375 92.390625 L 134.34375 86.71875 L 128.648438 86.71875 L 128.648438 81.046875 L 134.34375 81.046875 L 134.34375 75.378906 L 140.042969 75.378906 L 140.042969 81.046875 L 145.738281 81.046875 L 145.738281 86.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 124.953125 86.71875 L 119.257812 86.71875 L 119.257812 92.390625 L 113.5625 92.390625 L 113.5625 86.71875 L 107.863281 86.71875 L 107.863281 81.046875 L 113.5625 81.046875 L 113.5625 75.378906 L 119.257812 75.378906 L 119.257812 81.046875 L 124.953125 81.046875 L 124.953125 86.71875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 96.457031 96.027344 C 92.210938 103.523438 84.140625 108.589844 74.878906 108.589844 C 65.671875 108.589844 57.648438 103.585938 53.378906 96.167969 C 51.304688 92.5625 50.113281 88.390625 50.113281 83.9375 C 50.113281 70.320312 61.203125 59.285156 74.878906 59.285156 C 84.023438 59.285156 92.003906 64.226562 96.296875 71.570312 L 117.941406 59.160156 C 109.335938 44.375 93.273438 34.429688 74.878906 34.429688 C 47.410156 34.429688 25.144531 56.59375 25.144531 83.9375 C 25.144531 92.90625 27.542969 101.320312 31.734375 108.578125 C 40.3125 123.441406 56.421875 133.449219 74.878906 133.449219 C 93.367188 133.449219 109.5 123.398438 118.070312 108.492188 L 96.457031 96.027344 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCplusplus);
export default __webpack_public_path__ + "static/media/cplusplus.06f14ec409010a20c0b0cd916d5cc111.svg";
export { ForwardRef as ReactComponent };